var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',[_c('img',{attrs:{"src":_vm.logo,"alt":"","width":"50"}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("\n      "+_vm._s(_vm.titulo)+"\n      ")]),_vm._v(" "),_c('v-spacer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48afa577","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/mensagens/layout/MenuSuperior.vue
// module id = 885
// module chunks = 0